import { ArrowsClockwise, CircleNotch } from '@phosphor-icons/react';
import { Button } from '~/components/ui/button';

/** What the button says while it can be pressed. */
export const DRAFT_UPDATE_HINT = "The app has changes your draft doesn't have yet. Update brings them in.";
export const DRAFT_UPDATE_BUSY = 'Available once EDDY finishes the current run';
export const DRAFT_UPDATE_PENDING = "Bringing in the app's latest changes…";

/** The overlapping files a rework names, as the server capped them. */
export function overlapNames(files: string[], more: number): string {
  return more > 0 ? `${files.join(', ')} and ${more} more` : files.join(', ');
}

export interface DraftUpdateGate {
  show: boolean;
  /** Why it cannot be pressed right now; the button is disabled exactly when this is set. */
  blockedBy: string | null;
}

/** FRONT-2935: one decision for whether "Updates available" shows, and why it is unavailable. */
export function draftUpdateGate(input: { available: boolean; runBusy: boolean; pending: boolean }): DraftUpdateGate {
  if (!input.available && !input.pending) return { show: false, blockedBy: null };
  if (input.pending) return { show: true, blockedBy: DRAFT_UPDATE_PENDING };
  if (input.runBusy) return { show: true, blockedBy: DRAFT_UPDATE_BUSY };
  return { show: true, blockedBy: null };
}

export function DraftUpdateButton({ gate, pending, onUpdate }: { gate: DraftUpdateGate; pending: boolean; onUpdate: () => void }) {
  if (!gate.show) return null;
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onUpdate}
      disabled={gate.blockedBy !== null}
      tooltip={gate.blockedBy ?? DRAFT_UPDATE_HINT}
      aria-label="Updates available — bring them into your draft"
      data-testid="coding-draft-update"
      className="h-[34px] shrink-0 gap-1.5 rounded-[10px] px-2.5 text-[length:var(--text-sm)] text-primary"
    >
      {pending ? <CircleNotch size={16} className="animate-spin" /> : <ArrowsClockwise size={16} />}
      Updates available
    </Button>
  );
}
